<template>
  <div class="footer_box">
    <div v-html="htmls" />
    <p class="keep_on_record">
      <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">
        备案号：{{ keep_on_record_text }}
      </a>
    </p>
    <a href="http://www.cdjkyl.com/" target="_blank">
      成都金科玉律科技有限公司提供技术支持
    </a>
  </div>
</template>

<script>
import { fetchList, getaxios, getaxiosdata, deleteaxios, PostData, PostPut } from '@/api/official-article'
export default {
  name: 'Footer',
  data() {
    return {
      htmls: '',
      keep_on_record_text: ''
    }
  },
  created() {
    this.AxiosDelete()
  },
  methods: {
    async AxiosDelete() {
      await getaxiosdata('/plaintiff/api/home/getImgsByOrgCode').then(res => {
        if (res.code == 200) {
          const data = res.data
          // 循环判定保证获取的数据是正确的
          for (const i of data) {
            if (i.layoutId == 'BANNER') { // layoutId对应后台系统布局ID
              this.Banner_Img_Iist = i.imgs
            } else if (i.layoutId == 'OFFICIAL_TEXT') {
              this.htmls = i.imgs[1].layoutDesc.replace(/14px/g, '8px')
            } else if (i.layoutId == 'KEEP_ON_RECORD') {
              this.keep_on_record_text = i.imgs[0].layoutLink
            }
          }
        }
      })
    }

  }
}
</script>

<style lang="stylus" scoped>
.footer_box{
    text-align center
    padding 15px 50px
    color: #fff;
    font-size: 8px;
    line-height 15px
    background: #121212;
    p{
        span{
            color: #fff!important;
            font-size: 8px !important;
        }
    }
    a{
        color #fff
    }
}
</style>
